import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Mixpanel from "mixpanel-browser";

import ConfirmationModal from "../../common/modal/ConfirmationModal";
import { OK } from "../../constants/statusCode";
import { deleteLabel } from "../../features/user-document/deleteLabelSlice";
import { labelListing } from "../../features/user-document/label-listing";
import LabelSubMenu from "./LabelSubMenu";
import EditLabelModal from "./modal/EditLabelModal";
import LabelModal from "./modal/LabelModal";
import { getDocuments } from "../../features/user-document/documentListingSlice";

const LabelView = ({ labelDeteleToggel, perPage, currentPage, setSubCategories, currentModal, setCurrentModal, setSelectedCheckbox, selectedCheckbox, selectedRowsID }) => {
  // const [currentModal, setCurrentModal] = useState("");
  /* const [subCategories, setSubCategories] = useState("Documents"); */
  /* const [selectedCheckbox, setSelectedCheckbox] = useState(false); */
  const [labelID, setLabelId] = useState('');
  const [selectedLabel, setSelectedLabel] = useState('');
  let dispatch = useDispatch()
  const { listingData = null } = useSelector((state) => ({
    listingData: state?.labelListingSlice?.responseData?.label
  }));
  const toggleModal = () => {
    setCurrentModal("");
    setSelectedLabel("");
    setSelectedCheckbox("")
    setLabelId("");
  };
  let projectData = JSON.parse(localStorage.getItem("_user"));
  const handleDeleteLabel = async () => {
    Mixpanel.track("Delete label Button Clicked", {
      Page: "Delete label modal",
    });
    const { payload } = await dispatch(deleteLabel(labelID));
    if (payload.status === OK) {
      labelDeteleToggel();
      await dispatch(labelListing(projectData?.projects[0]?.uuid));
      await dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
        })
      );
      setLabelId('');
      setCurrentModal('');
    }
  }

  return (
    <>
      {listingData?.map((label, index) => (
        <LabelSubMenu
          label={label}
          setSubCategories={setSubCategories}
          setCurrentModal={setCurrentModal}
          setLabelId={setLabelId}
          labelDeteleToggel={labelDeteleToggel}
          setSelectedLabel={setSelectedLabel}
          setSelectedCheckbox={setSelectedCheckbox}
          key={index}
          selectedRowsID={selectedRowsID}
        />
      ))}
      {
        currentModal === "labelDeleteModal" && (
          <ConfirmationModal
            title={"Delete Label Confirmation"}
            isOpen={currentModal === "labelDeleteModal"}
            toggle={toggleModal}
            onConfirm={handleDeleteLabel}
            message="Are you sure you want to delete this label?"
          />
        )
      }

      {currentModal === 'labelModal' && (
        <LabelModal
          isOpen={currentModal === "labelModal"}
          toggle={toggleModal}
          labelID={labelID}
          setLabelId={setLabelId}
          selectedLabel={selectedLabel}
          selectedCheckbox={selectedCheckbox}
          setSelectedLabel={setSelectedLabel}
          setSelectedCheckbox={setSelectedCheckbox}
          perPage={perPage}
          currentPage={currentPage}
          setSubCategories={setSubCategories}
          setCurrentModal={setCurrentModal}
          currentModal={currentModal}
        />
      )}

      {currentModal === 'editLabelModal' &&
        (<EditLabelModal
          isOpen={currentModal === "editLabelModal"}
          toggle={toggleModal}
          labelID={labelID}
          setLabelId={setLabelId}
          selectedLabel={selectedLabel}
          selectedCheckbox={selectedCheckbox}
          setSelectedLabel={setSelectedLabel}
          setSelectedCheckbox={setSelectedCheckbox}
          perPage={perPage}
          currentPage={currentPage}
          setSubCategories={setSubCategories}
          setCurrentModal={setCurrentModal}
          currentModal={currentModal}
        />)
      }

    </>
  )
}

export default LabelView;